import { StringParam, useQueryParams } from "use-query-params";

export function useTabParam(initialTab: string): [string, (tab: string) => void] {
  const [{ tab }, setQueryParams] = useQueryParams({ tab: StringParam });
  function setTab(tab: string) {
    setQueryParams({ tab }, "pushIn");
  }
  return [tab || initialTab, setTab];
}
